// PrivateRoute.js
import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/auth-context';


const PrivateRoute = () => {
  const { currentUser } = useAuth();

  const location = useLocation();

  return currentUser !== null ? <Outlet /> : <Navigate to="/login" state={{ from: location }} />;
};

export default PrivateRoute;